export default {
  base: {
    display: 'flex',
    alignItem: 'center',
    variant: 'spark.base.wrapper'
  },
  variants: {},
  pages: {
    base: {
      display: ['none', 'flex']
    },
    variants: {
      mobile: {
        display: ['flex', 'none'],
        alignItems: 'center',
        mr: 20
      }
    }
  },
  link: {
    base: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 32,
      width: 32,
      mr: 20,
      textDecoration: 'none',
      color: 'grey-100',
      fontSize: 16
    },
    variants: {
      hover: {
        variant: 'spark.element.pagination.link.base',
        backgroundColor: 'grey-10'
      },
      focus: {
        variant: 'spark.element.pagination.link.variants.hover',
        borderStyle: 'solid',
        borderWidth: 2,
        borderColor: 'cyan',
        outline: 'none'
      },
      current: {
        variant: 'spark.element.pagination.link.variants.focus',
        borderColor: 'grey-100',
        backgroundColor: 'grey-0'
      }
    }
  }
};